import store from '@/store'

let isRefreshing = false
let failedQueue: { resolve: (token: string) => void; reject: (err: any) => void}[] = []

function processQueue(error: any, token: string | null = null) {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error)
    } else {
      prom.resolve(token!)
    }
  })
  failedQueue = []
}

const setup = (api: any) => {
  api.interceptors.request.use((config: any) => {
    const token = localStorage.getItem('ut')
    if (token) {
      // eslint-disable-next-line dot-notation
      config.headers.authorization = `${localStorage.getItem('tt')} ${token}`
    }
    return config
  }, (error: any) => Promise.reject(error))

  api.interceptors.response.use(async (response: any) => response, async (err: any) => {
    const originalRequest = err.config
    // eslint-disable-next-line no-underscore-dangle
    if (err.response.status === 401 && !originalRequest._retry) {
      const refreshToken = localStorage.getItem('rt')

      if (!refreshToken) {
        const userId = store.state.userProfile?.sid
        await store.dispatch('logoutAccount', userId)
        return Promise.reject(err)
      }

      if (isRefreshing) {
        return new Promise<string>((resolve, reject) => {
          failedQueue.push({ resolve, reject })
        })
          .then((token) => {
            // eslint-disable-next-line dot-notation
            originalRequest.headers.authorization = `${localStorage.getItem('tt')} ${token}`
            return api(originalRequest)
          })
          .catch((error) => Promise.reject(error))
      }

      // eslint-disable-next-line no-underscore-dangle
      originalRequest._retry = true
      isRefreshing = true

      try {
        const newToken = await store.dispatch('refreshToken')
        processQueue(null, newToken)

        // eslint-disable-next-line dot-notation
        originalRequest.headers.authorization = `${localStorage.getItem('tt')} ${newToken}`
        console.log('original', originalRequest)
        return api(originalRequest)
      } catch (error) {
        processQueue(error, null)
        const userId = store.state.userProfile?.sid
        await store.dispatch('logoutAccount', userId)
        return Promise.reject(error)
      } finally {
        isRefreshing = false
      }
    }
    return Promise.reject(err)
  })
}

export default setup
